import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Seguimiento } from "./components/seguimiento";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Testimonials } from "./components/testimonials";
import { Solicitud } from "./components/solicitud";
import { Team} from "./components/Team"
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {Gallery} from "./components/gallery"
import Swal from "sweetalert2";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  Swal.fire({
    title: '<h2 style="background-color:tomato">COMUNICADO</h2>',
    html: "<p>El <b>Ministerio de Gobierno</b> comunica a los usuarios de la plataforma <strong>Estado Digital ED3 - Vidrios Oscurecidos o Polarizados</strong>, que a través de <b >Resolución Ministerial Nº 167/2024</b> se aprueba las modificaciones al Reglamento de Autorización de Vidrios Oscurecidos o Polarizados, el mismo que actualiza los requisitos para los diversos tipos de autorización.</p>",
    icon: "warning",
    allowOutsideClick: false,
    confirmButtonColor: '#262839'
  });
  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery}/>
      <Testimonials data={landingPageData.Testimonials} />
      {/* <Team data={landingPageData.Team} /> */}
      <Seguimiento data={landingPageData.Seguimiento} />
      <Solicitud data={landingPageData.Solicitud} />
    </div>
  );
};

export default App;
